<p class="text-muted">The data generated is based on the invoices reviewed for the selected duration.
</p>
<div class="khr-supplier-tab">
    <div class="statistic-total my-3">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="total-card total-supplier mb-xs-2">
                    <div class="card-subtitle">
                        <p class="mb-0 w-100">Total no. of Suppliers</p>
                    </div>
                    <app-table-loader *ngIf="isSupplierLoading"></app-table-loader>
                    <div *ngIf="!isSupplierLoading"
                        class="growth-rate d-flex align-items-end justify-content-between">
                        <div class="h3 mb-0 text-black">
                            {{ sharedService.formatNumber(supplierCount?.suppliers) }}
                        </div>
                        <!-- <span class="d-flex align-items-center text-success">
                        <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">arrow_downward</i>
                        <span class="">-14%</span> 
                    </span> -->
                        <!-- <span class="d-flex align-items-center percentage-value">
                            <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                                {{ supplierCount?.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                            </i>
                            <span class="pf-cursor-pointer"
                                container="body"
                                pmdTooltip="Your total supplier has {{ supplierCount?.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(supplierCount?.change >= 0 ? supplierCount?.change : supplierCount?.change * -1) }}% compared to the previous period."
                                placement="bottom">
                                {{ sharedService.formatNumber(supplierCount?.change) }}%
                            </span>
                        </span> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="total-card total-invoices mb-xs-2">
                    <div class="card-subtitle">
                        <p class="mb-0 w-100">Total no. of invoices</p>
                    </div>
                    <app-table-loader *ngIf="isReviewedInvoiceLoading"></app-table-loader>
                    <div *ngIf="!isReviewedInvoiceLoading"
                        class="growth-rate d-flex align-items-end justify-content-between">
                        <div class="h3 mb-0 text-black">
                            {{ sharedService.formatNumber(reviewedInvoiceCount?.count) }}
                        </div>
                        <!-- <span class="d-flex align-items-center text-success">
                        <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">arrow_downward</i>
                        <span class="">-14%</span> 
                    </span> -->
                        <!-- <span class="d-flex align-items-center percentage-value">
                            <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                                {{ reviewedInvoiceCount.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                            </i>
                            <span class="pf-cursor-pointer"
                                container="body"
                                pmdTooltip="Your total reviewed invoice has {{ reviewedInvoiceCount.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(reviewedInvoiceCount.change >= 0 ? reviewedInvoiceCount.change : reviewedInvoiceCount.change * -1) }}% compared to the previous period."
                                placement="bottom">
                                {{ sharedService.formatNumber(reviewedInvoiceCount?.change) }}%
                            </span>
                        </span> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="total-card total-amount">
                    <div class="card-subtitle">
                        <p class="mb-0">Total Payable Amount</p>
                    </div>
                    <app-table-loader *ngIf="isInvoiceAmountLoading"></app-table-loader>
                    <div *ngIf="!isInvoiceAmountLoading"
                        class="growth-rate d-flex align-items-end justify-content-between">
                        <div class="h3 mb-0 text-black">
                            {{ sharedService.formatNumber(invoiceAmount?.amount, true) }}
                        </div>
                        <!-- <span class="d-flex align-items-center percentage-value">
                            <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                                {{ invoiceAmount.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                            </i>
                            <span class="pf-cursor-pointer"
                                container="body"
                                pmdTooltip="Your total payable amount of invoices has {{ invoiceAmount.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(invoiceAmount.change >= 0 ? invoiceAmount.change : invoiceAmount.change * -1) }}% compared to the previous period."
                                placement="bottom">
                                {{ sharedService.formatNumber(invoiceAmount?.change) }}%
                            </span>
                        </span> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="total-card total-gst mb-xs-0 ">
                    <div class="card-subtitle">
                        <p class="mb-0 w-100">Total Taxes</p>
                    </div>
                    <app-table-loader *ngIf="isInvoiceGstLoading"></app-table-loader>
                    <div *ngIf="!isInvoiceGstLoading"
                        class="growth-rate d-flex align-items-end justify-content-between">
                        <div class="h3 mb-0 text-black">
                            {{ sharedService.formatNumber(invoiceGst?.gst, true) }}
                        </div>
                        <!-- <span class="d-flex align-items-center percentage-value">
                            <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                                {{ invoiceGst.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                            </i>
                            <span class="pf-cursor-pointer"
                                container="body"
                                pmdTooltip="Your total taxes of invoices has {{ invoiceGst.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(invoiceGst.change >= 0 ? invoiceGst.change : invoiceGst.change * -1) }}% compared to the previous period."
                                placement="bottom">
                                {{ sharedService.formatNumber(invoiceGst?.change) }}%
                            </span>
                        </span> -->
                    </div>
                </div>
            </div>

        </div>
    </div>
    <pmd-card class="box-shadow-none px-3 py-3 mb-xs-2">
        <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div class="card-title h6 text-black d-flex align-items-center">
                <span>Suppliers List </span>
                <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
                    container="body"
                    pmdTooltip="This report will provide the data at supplier level for the reviewed invoices."
                    placement="bottom">info</i>

                <!-- * Download invoice summary report -->
                <div class="loader-wrap"
                    *ngIf="downloadReport">
                    <app-table-loader class="h-50"></app-table-loader>
                </div>

                <button type="button"
                    *ngIf="!downloadReport"
                    pmd-btn
                    pmdripple
                    color="secondary"
                    pmd-btn-outline
                    class="pmd-btn-icon px-2 py-1 ms-2"
                    size="sm"
                    (click)="downloadSupplierInvoiceSummaryReport()">
                    <svg width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        pmdTooltip="Download"
                        xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_218_123"
                            style="mask-type:alpha"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24">
                            <rect width="24"
                                height="24"
                                fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_218_123)">
                            <path
                                d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z"
                                fill="#000" />
                            <path d="M17 11L12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11Z"
                                fill="#000" />
                        </g>
                    </svg>
                </button>
            </div>
            <form class="form-inline search-box"
                [formGroup]="supplierFilterForm">
                <pmd-input-group-outline pmd-input-group-icon
                    class="mb-3 input-group-sm">
                    <pmd-input-group-text>
                        <svg xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-search"
                            viewBox="0 0 16 16">
                            <path fill="#556075"
                                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                    </pmd-input-group-text>
                    <pmd-textfield-outline>
                        <input pmdTextField
                            type="text"
                            placeholder="Search..."
                            class="form-control form-control-sm rounded-start"
                            formControlName="searchTerm"
                            aria-label="Username"
                            aria-describedby="username">
                        <i (click)="clearSupplierFilter()"
                            *ngIf="f.searchTerm.value"
                            class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer clear-input ">
                            close
                        </i>
                    </pmd-textfield-outline>

                </pmd-input-group-outline>

            </form>
        </div>
        <p class="text-muted mt-0 mb-3">
            Shows Supplier-wise Invoice Amount, GST Amount, and Number of Invoices over the selected date range.
        </p>
        <!-- <div class="row mt-3 align-items-center mb-3 shorting-btn" >
        <h6 class="mb-0 col-auto">10 Invoices Selected...</h6>
        <div class="col d-flex mt-sm-0">
            <button type="button" pmd-btn-outline pmdRipple color="dark" size="sm" routerLink="/preview-invoice" class="me-2 pmd-btn-icon col-auto">
                <i class="material-symbols-outlined material-icons-round pmd-icon-xs">delete</i> <span class="media-body d-none d-sm-inline">Delete selected</span>
            </button>
        </div>
    </div> -->

        <app-table-loader *ngIf="isSupplierListLoading"
            class="my-5 d-flex">
        </app-table-loader>

        <!-- Table List -->
        <div *ngIf="!isSupplierListLoading && filteredSupplierList.length"
            class="pmd-table-header-fixed khr-supplier-table mt-3">
            <div class="scrollbar">
                <!-- <div class=" table-responsive table-responsive-md p-0 mt-3" > -->
                <table cellspacing="0"
                    cellpadding="0"
                    class="table pmd-table"
                    role="grid"
                    id="table-propeller">
                    <thead class="header thead-light">
                        <tr class="thead-bg">
                            <th class="column-sorting"
                                rowspan="2"
                                (click)="sortSuppliers('name')">
                                <div class="d-flex align-items-center">Supplier Name
                                    <span class="material-symbols-outlined pmd-icon-xs ms-1">
                                        {{ sortBy === 'name' ?
                                        sortOrder === 'ASC' ? 'arrow_downward' : 'arrow_upward' : '' }}
                                    </span>
                                </div>
                            </th>
                            <th class="column-sorting"
                                rowspan="2">
                                No. of <br>Invoices
                            </th>
                            <th class="column-sorting text-end"
                                rowspan="2">
                                Taxable <br>Amount (₹)
                            </th>
                            <th class="column-sorting text-center border-1"
                                colspan="4">
                                Taxes (₹)
                            </th>
                            <th class="column-sorting text-end"
                                rowspan="2">
                                TDS <br>Amount (₹)
                            </th>
                            <th class="column-sorting text-end"
                                rowspan="2">
                                TCS <br>Amount (₹)
                            </th>
                            <th class="column-sorting text-end"
                                rowspan="2">
                                Other Charges (₹)
                            </th>
                            <th class="column-sorting text-end"
                                rowspan="2">
                                Payable <br>Amount (₹)
                            </th>
                        </tr>
                        <tr class="thead-bg">
                            <th class="text-center border-1">
                                GST (₹)
                            </th>
                            <th class="text-center border-1">
                                VAT (₹)
                            </th>
                            <th class="text-center border-1">
                                CESS (₹)
                            </th>
                            <th class="text-center border-1">
                                Excise (₹)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let supplier of filteredSupplierList; let i = index">
                            <tr>
                                <td tabindex="-1"
                                    class="">
                                    <div class="d-flex">
                                        <div class="flex-grow-1">
                                            <div class="card-title mb-1 supplier-name-truncate"
                                                container="body"
                                                [pmdTooltip]="sharedService.capitalize(supplier.name)">
                                                {{ sharedService.capitalize(supplier.name) }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td data-title="Invoice Count."
                                    tabindex="-1"
                                    class=""
                                    aria-describedby="courseSimulator">
                                    <p class="card-title mb-1">
                                        {{ sharedService.formatNumber(supplier.count) }}
                                    </p>
                                </td>
                                <td data-title="Taxable Amount"
                                    class="text-lg-end text-sm-start text-end">
                                    <p class="card-title mb-1">
                                        {{ sharedService.formatNumber(supplier.taxableAmount, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="GST"
                                    class="text-center border-1">
                                    <p class="card-title mb-1">
                                        {{ sharedService.formatNumber(supplier.gst, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="VAT"
                                    class="text-center border-1">
                                    <p class="card-title mb-1">
                                        {{ sharedService.formatNumber(supplier.vat, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="CESS"
                                    class="text-center border-1">
                                    <p class="card-title mb-1">
                                        {{ sharedService.formatNumber(supplier.cess, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="Excise"
                                    class="text-center border-1">
                                    <p class="card-title mb-1">
                                        {{ sharedService.formatNumber(supplier.excise, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="TDS Amount"
                                    class="text-end">
                                    <p class="card-title mb-0">
                                        {{ sharedService.formatNumber(supplier.tds, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="TCS Amount"
                                    class="text-end">
                                    <p class="card-title mb-0">
                                        {{ sharedService.formatNumber(supplier.tcs, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="otherCharges"
                                    class="text-end">
                                    <p class="card-title mb-0">
                                        {{ sharedService.formatNumber(supplier.otherCharges, true, 0, 2, true) }}
                                    </p>
                                </td>
                                <td data-title="Payable"
                                    class="text-end">
                                    <p class="card-title mb-0">
                                        {{ sharedService.formatNumber(supplier.amount, true, 0, 2, true) }}
                                    </p>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <!-- </div> -->
            </div>
        </div>
        <!-- End Table List -->
        <!-- No Data Found -->
        <!-- <div *ngIf="!isSupplierListLoading && !filteredSupplierList.length"
        class="blank-state text-center mt-5 row justify-content-center">
        <div class="col-6">
            <div class="mb-3 pmd-avatar pmd-avatar-primary pmd-avatar-lg d-inline-flex"
                aria-hidden="true">
                <span class="material-icons material-symbols-outlined pmd-icon-primary pmd-icon-md"
                    aria-hidden="true">
                    description
                </span>
            </div>
            <h2 class="h3"
                tabindex="0">No information found!</h2>
            <p class="mb-4"
                tabindex="0">It seems no invoices reviewed yet. Once the invoice will be reviewed, you
                will get supplier's information here.</p>
        </div>
    </div> -->
        <app-empty-chart *ngIf="!isSupplierListLoading && !filteredSupplierList.length">
        </app-empty-chart>
        <!-- End No Data Found -->
    </pmd-card>
    <pmd-card class="px-3 pt-3 box-shadow-none card-supplier-overview mb-xs-2">
        <h4 class="h5 cart-title d-flex align-items-center">
            <span class="text-black">Supplier-wise Amount contribution</span>
            <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75 "
                container="body"
                pmdTooltip="Shows Supplier wise % contribution to the Total Taxable Amount."
                placement="bottom">info</i>
        </h4>
        <div class="loader-wrap"
            *ngIf="isSupplierWiseSummaryLoading">
            <app-table-loader class="h-100"></app-table-loader>
        </div>
        <app-treemap-chart *ngIf="!isSupplierWiseSummaryLoading && treemapSeries?.length"
            [series]="treemapSeries"
            [customTooltip]="treemapCustomTooltip">
        </app-treemap-chart>
        <app-empty-chart *ngIf="!isSupplierWiseSummaryLoading && !treemapSeries?.length"></app-empty-chart>
        <!-- <div class="position-relative">
                <div class="card-title text-center">
                    <div class="h6 mb-4">
                        Invoice Amount wise distribution of Suppliers
                    </div> 
                </div>
            </div> -->
    </pmd-card>
    <pmd-card class="px-3 pt-3 box-shadow-none">
        <h4 class="h5 cart-title d-flex align-items-center mb-4">
            <span class="text-black">Supplier-wise Amount</span>
            <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
                container="body"
                pmdTooltip="Supplier-wise Amount"
                placement="bottom">info</i>
        </h4>
        <!-- <div class="chart-filter d-flex">
                <span class="badge me-1 bg-light text-dark"> Daily </span>
                <span class="badge me-1 bg-secondary"> Weekly </span>
                <span class="badge bg-light text-dark"> Monthly </span>
            </div> -->
        <div class="loader-wrap"
            *ngIf="isSupplierWiseSummaryLoading">
            <app-table-loader class="h-100"></app-table-loader>
        </div>
        <app-mixed-chart *ngIf="!isSupplierWiseSummaryLoading && mixedCategories?.length"
            [series]="mixedSeries"
            [categories]="mixedCategories"
            [yAxisRange]="mixedYAxisRange"
            [isProduct]="false"
            [customTooltip]="mixedCustomTooltip">
        </app-mixed-chart>
        <app-empty-chart *ngIf="!isSupplierWiseSummaryLoading && !mixedCategories?.length"></app-empty-chart>
    </pmd-card>
</div>